import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, inject } from '@angular/core';
import { InputMomentPickerComponent } from '@controls/input-moment-picker/input-moment-picker.component';
import { FILTER_DIALOG_DATA } from '@models/dialog';
import { FilterData } from '@models/filter-models';
import { SharedModule } from '@modules/shared.module';
import { endOfDay } from 'date-fns';
import { FilterComponent } from './filter.component';

/** @deprecated */
@Component({
  templateUrl: 'filter-report-date.component.html',
  styleUrls: ['filter-report-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule, InputMomentPickerComponent],
})
export class FilterReportDateComponent extends FilterComponent {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  _datePipe: DatePipe;
  _date = 0;

  constructor(@Inject(FILTER_DIALOG_DATA) data: FilterData) {
    super(data);
    this._datePipe = new DatePipe('en-US');
  }

  get date(): number {
    return this._date;
  }

  set date(value: number) {
    this._date = value;
    if (value === 1 && (this.dateFrom || this.dateEnd)) {
      this.setValue('date', this.getDateDisplay(this.dateFrom, this.dateEnd), 1);
    } else {
      this.removeValue('date');
    }
  }

  get dateFrom(): Date | undefined {
    return this.getValue('dateFrom');
  }

  set dateFrom(value: Date | undefined) {
    if (value) {
      this.setValue('dateFrom', undefined, value);
    } else {
      this.removeValue('dateFrom');
    }

    this.date = 1;
  }

  get dateEnd(): Date | undefined {
    return this.getValue('dateEnd');
  }

  set dateEnd(value: Date | undefined) {
    if (value) {
      this.setValue('dateEnd', undefined, endOfDay(value));
    } else {
      this.removeValue('dateEnd');
    }

    this.date = 1;
  }

  getDateDisplay(dateFrom: Date | undefined, dateEnd: Date | undefined): string | undefined {
    let range = '';
    if (dateFrom && dateEnd) {
      range = `from ${this._datePipe.transform(dateFrom, 'shortDate')} to ${this._datePipe.transform(dateEnd, 'shortDate')}`;
    } else if (dateFrom) {
      range = `from ${this._datePipe.transform(dateFrom, 'shortDate')}`;
    } else if (dateEnd) {
      range = `until ${this._datePipe.transform(dateEnd, 'shortDate')}`;
    }

    return `Range: ${range}`;
  }

  filtersChanged(): void {
    const date = this.getValue('date');
    if (typeof date === 'number') {
      this._date = date;
    } else if (date == null) {
      this._date = 0;
    }

    this.changeDetectorRef.markForCheck();
  }
}
